export const DEFAULT_SELECT_OPTION = '';

export enum ComplianceStatus {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum ComplianceDocumentStatus {
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS',
  DRAFT_AVAILABLE = 'DRAFT_AVAILABLE',
  EXECUTED = 'EXECUTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

/**
 * Construction progress of a new-build battery project. Mirrors the backend
 * `ConstructionStage` enum (com.cleantrade.core.enums.ConstructionStage). Display
 * labels come from `/reference/construction-stages`.
 */
export enum ConstructionStage {
  PRE_NTP = 'PRE_NTP',
  NTP_ISSUED = 'NTP_ISSUED',
  MOBILIZED = 'MOBILIZED',
  EQUIPMENT_ON_SITE = 'EQUIPMENT_ON_SITE',
  COMMISSIONING = 'COMMISSIONING',
}

/**
 * Notice to proceed status of a new-build battery project. Mirrors the backend
 * `NoticeToProceedStatus` enum. Display labels come from
 * `/reference/notice-to-proceed-statuses`.
 */
export enum NoticeToProceedStatus {
  NOT_ISSUED = 'NOT_ISSUED',
  LIMITED_NTP = 'LIMITED_NTP',
  FULL_NTP = 'FULL_NTP',
}

/**
 * Procurement status of a new-build battery project's long-lead equipment. Mirrors
 * the backend `LongLeadEquipmentStatus` enum. Display labels come from
 * `/reference/long-lead-equipment-statuses`.
 */
export enum LongLeadEquipmentStatus {
  NOT_ORDERED = 'NOT_ORDERED',
  ORDERED = 'ORDERED',
  DELIVERY_SCHEDULED = 'DELIVERY_SCHEDULED',
  DELIVERED = 'DELIVERED',
}

/**
 * Any status value shown on the project diligence view, used by the status chip
 * color helpers.
 */
export type DiligenceStatus =
  | ComplianceDocumentStatus
  | ComplianceStatus
  | ConstructionStage
  | NoticeToProceedStatus
  | LongLeadEquipmentStatus;
